var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFadSliderhandle1 = function SvgFadSliderhandle1(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 256 256",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64.254 32.888C63.56 28.532 66.584 25 70.996 25h113.008c4.416 0 7.477 3.545 6.875 7.913 0 0-6.879 43.782-6.879 95.218 0 51.435 6.875 94.961 6.875 94.961.621 4.368-2.46 7.908-6.871 7.908H70.996c-4.416 0-7.402-3.537-6.714-7.899 0 0 7.718-42.667 7.718-94.474 0-51.808-7.746-95.739-7.746-95.739z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80 40h96s-6.533 44.489-6.533 88.521C169.467 172.554 176 217 176 217H80s8-44.218 8-88.479C88 84.261 80 40 80 40z",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M95 57h65l-4 16H98zm5 125h55l5 19H96zm4-58h48v9h-48z"
  }))));
};
export { SvgFadSliderhandle1 as ReactComponent };
export default __webpack_public_path__ + "static/media/fad-sliderhandle-1.c302503a.svg";